/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { connect } from 'react-redux';
import classnames from 'classnames';

import BackgroundFooter from './BackgroundFooter';
import GroupMenuSwitcher from 'components/features/GroupMenuSwitcher';

import './AppFrame.css';

import { selectors as systemModalSelectors}  from 'redux/reduxStore/systemModal';

function mapStateToProps(state) {
  return {
    systemModalEnabled: systemModalSelectors.isVisible(state) || systemModalSelectors.isLocalModalVisible(state),
    blurClassName: systemModalSelectors.getBlurClassName(state),
  };
}

class AppFrame extends React.Component {
  UNSAFE_componentWillReceiveProps(nextProps) {
    const intercomContainer = document.querySelector('#intercom-container');
    const { systemModalEnabled } = nextProps;

    if (intercomContainer) {
      intercomContainer.classList.toggle('system-modal-enabled', systemModalEnabled);
    }
  }

  render() {
    const { SiteMap, children, onClickLogo, systemModalEnabled, blurClassName } = this.props;
    const blurClass = systemModalEnabled ? blurClassName : '';

    return (
      <div className={classnames('cmp-appframe', blurClass, { 'system-modal-enabled': systemModalEnabled })}>
        <div className="sidebar">
          <div className="sidebarheading">
            <GroupMenuSwitcher onClick={onClickLogo} hideName />
          </div>

          <div>
            { SiteMap ? <SiteMap /> : null}
          </div>
        </div>

        <div className="cmp-appframe-content responsive-frame-content">
          <div className="content">
            {children}
          </div>
          <div className="footer">
            <BackgroundFooter />
          </div>
        </div>
        <div className="frame-background" />
      </div>
    );
  }
}

export default connect(mapStateToProps)(AppFrame);
